export const optionDetails = {
  "TrackWise": {
    heading: "TrackWise",
    translations: {
      English: {
        Question1: "How does QCM Trackwise assist you in your day-to-day work?",
        Question2: "How can the IT Service Team better assist you if a QCM Trackwise problem arises?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "QCM TrackWise 是如何帮助您完成日常工作的？",
        Question2: "如果出现 QCM TrackWise 问题，IT 服务团队如何更好地协助您？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "QCM Trackwise は、日常業務にどのように役立っていますか？",
        Question2: "QCM Trackwise の問題が発生した場合、IT サービスチームはどのように支援できますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Comment QCM Trackwise vous aide-t-il dans votre travail quotidien ?",
        Question2: "Comment l'équipe de service informatique pourrait-elle mieux vous assister en cas de problème avec QCM Trackwise ? ",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Cómo le ayuda QCM Trackwise en su trabajo diario?",
        Question2: "¿Cómo puede el equipo de servicio de TI ayudarlo mejor si surge un problema con QCM Trackwise? ",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe helpt QCM Trackwise u bij uw dagelijkse werk?",
        Question2: "Hoe kan het IT-serviceteam u beter helpen als er een probleem met QCM Trackwise ontstaat?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie unterstützt Sie QCM Trackwise in Ihrer täglichen Arbeit?",
        Question2: "Wie kann das IT-Service-Team Sie besser unterstützen, wenn ein QCM Trackwise-Problem auftritt? ",
        optionalText:"(optional)"
      }
    }
  },
 
  "ServiceMax": {
    heading: "ServiceMax",
    translations: {
      English: {
        Question1: "How effectively is Servicemax assisting you in carrying out your regular job duties?",
        Question2: "Which ServiceMax functionality or feature do you think could use some improvement? What is the most pressing issue that has to be resolved?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "ServiceMax 在协助您完成日常工作任务方面效果如何？",
        Question2: "您认为 ServiceMax 的哪项功能或特性还有改进的空间？需要解决的最紧迫问题是什么？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "ServiceMax は、日常業務にどの程度役立っていますか？",
        Question2: "改善が必要だと思う ServiceMax の機能や特徴はどれですか？解決するべき最も差し迫った問題は何ですか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Dans quelle mesure Servicemax vous aide-t-il à accomplir vos tâches quotidiennes?",
        Question2: "Quelle fonctionnalité ou caractéristique de ServiceMax pensez-vous qu'il serait utile d'améliorer? Quel est le problème le plus urgent à résoudre?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué tan bien le ayuda Servicemax en sus tareas diarias?",
        Question2: "¿Qué funcionalidad o característica de ServiceMax cree que podría mejorarse? ¿Cuál es el problema más urgente que debe resolverse?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe effectief helpt ServiceMax u bij het uitvoeren van uw dagelijkse taken?",
        Question2: "Welke functionaliteit of functie van ServiceMax denkt u dat verbetering behoeft? Wat is het meest dringende probleem dat moet worden opgelost?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie effektiv unterstützt Sie Servicemax bei der Durchführung Ihrer täglichen Aufgaben?",
        Question2: "Welche Funktionalität oder welches Merkmal von ServiceMax könnte Ihrer Meinung nach verbessert werden? Welches ist das dringendste Problem, das gelöst werden muss?",
        optionalText:"(optional)"
      }
    }
  },
 
  "Philips voice cloud": {
    heading: "Philips Voice Cloud",
    translations: {
      English: {
        Question1: "How well can you carry out your regular job duties using Philips Voice Cloud?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "通过Philips voice cloud，您能将日常工作任务完成的多好呢？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "Philips Voice Cloud を使用して通常の業務をどの程度行えますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Dans quelle mesure pouvez-vous accomplir vos tâches quotidiennes en utilisant Philips Voice Cloud ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué tan bien puede realizar sus tareas diarias usando Philips Voice Cloud?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe goed kunt u uw dagelijkse taken uitvoeren met Philips Voice Cloud?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie gut können Sie Ihre täglichen Aufgaben mit Philips Voice Cloud erledigen?",
        optionalText:"(optional)"
      }
    }
  },
  "Philips product library": {
    heading: "Philips Product Library",
    translations: {
      English: {
        Question1: "How can we improve the service of the Philips product library team?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "我们能如何改进Philips product library服务呢？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "フィリップス製品ライブラリチームのサービスをどのように改善できますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Comment pouvons-nous améliorer le service de l'équipe de la bibliothèque de produits Philips ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Cómo podemos mejorar el servicio del equipo de la biblioteca de productos de Philips?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe kunnen we de service van het Philips productbibliotheekteam verbeteren?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie können wir den Service des Philips-Produktbibliotheksteams verbessern?",
        optionalText:"(optional)"
 
      }
    }
  },
  "Philips asset library": {
    heading: "Philips Asset Library",
    translations: {
      English: {
        Question1: "How can we improve the service of the Philips asset library team?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "我们能如何改进Philips asset library服务呢？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "フィリップス資産ライブラリチームのサービスをどのように改善できますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Comment pouvons-nous améliorer le service de l'équipe de la bibliothèque d'actifs Philips ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Cómo podemos mejorar el servicio del equipo de la biblioteca de activos de Philips?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe kunnen we de service van het Philips assetbibliotheekteam verbeteren?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie können wir den Service des Philips-Asset-Bibliotheksteams verbessern?",
        optionalText:"(optional)"
      }
    }
  },
  "IT Portal": {
    heading: "IT Portal",
    translations: {
      English: {
        Question1: "What element of the IT Portal is your favorite? Which do you enjoy most?",
        Question2: "Was it simple for you to locate what you were searching for on the IT Portal? Do you have any suggestions for making it better?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "您最喜欢 IT 门户的哪个元素？ 哪个是您最喜欢的？",
        Question2: "您是否能够轻松地在 IT 门户找到需要的内容？ 有什么改进的建议吗？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "IT ポータルの要素でお気に入りのものはどれですか？ どれが一番好きですか？",
        Question2: "IT ポータルで探していたものを簡単に見つけることができましたか？ 改善の提案はありますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Quel élément du portail IT préférez-vous ? Lequel appréciez-vous le plus ?",
        Question2: "Avez-vous trouvé facilement ce que vous cherchiez sur le portail IT ? Avez-vous des suggestions pour l'améliorer ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué elemento del portal de TI es tu favorito? ¿Cuál disfrutas más?",
        Question2: "¿Fue fácil para ti encontrar lo que buscabas en el portal de TI? ¿Tienes alguna sugerencia para mejorarlo?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Welk element van het IT-portaal is uw favoriet? Welke vindt u het leukst?",
        Question2: "Was het eenvoudig voor u om te vinden wat u zocht op het IT-portaal? Heeft u suggesties om het te verbeteren?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Welches Element des IT-Portals ist Ihr Favorit? Welches mögen Sie am meisten?",
        Question2: "War es einfach für Sie, auf dem IT-Portal zu finden, wonach Sie gesucht haben? Haben Sie Verbesserungsvorschläge?",
        optionalText:"(optional)"
      }
    }
  },
  "Health care imaging and ultrasound": {
    heading: "Health Care Imaging and Ultrasound",
    translations: {
      English: {
        Question1: "Kindly inform us of any ideas, problems, or concerns with the current IT business process regarding the Health care imaging and ultrasound systems.",
        Question2: "Please report a recurring incident or issue that you face in the Health Care Imaging and Ultrasound systems.",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "请告知我们您对当前医疗成像和超声系统相关 IT 业务流程的任何想法、问题或担忧。",
        Question2: "请告知您在医疗成像和超声系统中遇到的重复性事件或问题。",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "現在の医療用画像処理および超音波システムに関連するIT業務プロセスに関するアイデア、問題、または懸念事項をお知らせください。",
        Question2: "医療用画像処理および超音波システムで発生する繰り返しのインシデントや問題を報告してください。",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Veuillez nous faire part de vos idées, problèmes ou préoccupations concernant le processus commercial IT actuel pour les systèmes d'imagerie et d'échographie médicales.",
        Question2: "Veuillez signaler un incident ou un problème récurrent dans les systèmes d'imagerie et d'échographie médicales.",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "Infórmenos sobre cualquier idea, problema o inquietud con el proceso de TI actual en relación con los sistemas de imágenes y ultrasonido en el cuidado de la salud.",
        Question2: "Informe un incidente recurrente o problema que enfrenta en los sistemas de imágenes y ultrasonido en el cuidado de la salud.",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Laat ons alstublieft weten of u ideeën, problemen of zorgen heeft over het huidige IT-bedrijfsproces met betrekking tot de systemen voor medische beeldvorming en echografie.",
        Question2: "Meld een terugkerend incident of probleem dat u ondervindt in de systemen voor medische beeldvorming en echografie.",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Bitte teilen Sie uns Ihre Ideen, Probleme oder Bedenken bezüglich des aktuellen IT-Geschäftsprozesses im Bereich der medizinischen Bildgebung und Ultraschallsysteme mit.",
        Question2: "Bitte melden Sie ein wiederkehrendes Ereignis oder Problem, dem Sie in den Systemen für medizinische Bildgebung und Ultraschall begegnen.",
        optionalText:"(optional)"
      }
    }
  },
  "Salesforce cCRM": {
    heading: "Salesforce cCRM",
    translations: {
      English: {
        Question1: "Which cCRM program features don't help you effectively carry out your regular job duties?",
        Question2: "Which essential cCRM function or process would you like to see improved?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "哪些 cCRM 程序功能没有帮助您有效地完成日常工作？",
        Question2: "您希望改进哪些关键的 cCRM 功能或流程？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "cCRM プログラムのどの機能が日常業務の遂行に役立っていないと思いますか？",
        Question2: "改善してほしい重要な cCRM 機能やプロセスはどれですか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Quelles fonctionnalités du programme cCRM ne vous aident pas efficacement dans vos tâches quotidiennes?",
        Question2: "Quelle fonction ou processus essentiel de cCRM aimeriez-vous voir amélioré?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué características del programa cCRM no le ayudan a llevar a cabo eficazmente sus tareas diarias?",
        Question2: "¿Qué función o proceso esencial de cCRM le gustaría ver mejorado?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Welke functies van het cCRM-programma helpen u niet effectief bij het uitvoeren van uw dagelijkse taken?",
        Question2: "Welke essentiële cCRM-functie of -proces zou u graag verbeterd zien?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Welche Funktionen des cCRM-Programms helfen Ihnen nicht effektiv bei der Erledigung Ihrer täglichen Aufgaben?",
        Question2: "Welche wesentliche cCRM-Funktion oder -Prozess möchten Sie verbessert sehen?",
        optionalText:"(optional)"
      }
    }
  },
  "Health care - MP1 - Commercial": {
    heading: "Health Care - MP1 - Commercial",
    translations: {
      English: {
        Question1: "How can we improve the services of the MP1 / Commercial system team?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "我们如何改进 MP1 – Commercial系统服务？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "MP1 / コマーシャル システム チームのサービスをどのように改善できますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Comment pouvons-nous améliorer les services de l'équipe système MP1 / Commercial ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Cómo podemos mejorar los servicios del equipo del sistema MP1 / Comercial?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Hoe kunnen we de diensten van het MP1 / Commercieel systeemteam verbeteren?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Wie können wir die Dienstleistungen des MP1 / Commercial-Systems-Teams verbessern?",
        optionalText:"(optional)"
      }
    }
  },
  "Conga (Apttus) CPQ CLM": {
    heading: "Conga (Apttus) CPQ CLM",
    translations: {
      English: {
        Question1: "What about Apttus (Conga) do you enjoy best?",
        Question2: "What would need to change for Apptus to be more valuable to you?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "关于 Apttus (Conga)，您最喜欢什么？",
        Question2: "Apttus 需要做出哪些改进才能对您更有价值？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "Apttus (Conga) のどの点が気に入っていますか？",
        Question2: "Apttus をより価値あるものにするためには、どのような変更が必要ですか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Qu'appréciez-vous le plus à propos d'Apttus (Conga) ?",
        Question2: "Que faudrait-il changer pour qu'Apttus vous soit plus utile ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué es lo que más le gusta de Apttus (Conga)?",
        Question2: "¿Qué tendría que cambiar para que Apttus le resulte más valioso?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Wat vindt u het leukst aan Apttus (Conga)?",
        Question2: "Wat zou er moeten veranderen om Apttus waardevoller voor u te maken?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Was gefällt Ihnen an Apttus (Conga) am besten?",
        Question2: "Was müsste sich ändern, damit Apttus für Sie wertvoller wird?",
        optionalText:"(optional)"
      }
    }
  },
  "Planisware": {
    heading: "Planisware",
    translations: {
      English: {
        Question1: "What can we do to enhance the services provided by the Planisware team?",
        Question2: "What issues do you have with the current IT business process around Planisware? Any suggestions for improvement?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "我们可以做些什么来增强 Planisware 团队提供的服务？",
        Question2: "您对当前 Planisware 的 IT 业务流程有哪些问题？ 有什么改进的建议吗？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "Planisware チームが提供するサービスを強化するために何ができますか？",
        Question2: "Planisware に関する現在の IT 業務プロセスにどのような問題がありますか？ 改善の提案はありますか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Que pouvons-nous faire pour améliorer les services fournis par l'équipe Planisware ?",
        Question2: "Quels problèmes avez-vous avec le processus métier IT actuel autour de Planisware ? Des suggestions d'amélioration ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué podemos hacer para mejorar los servicios proporcionados por el equipo de Planisware?",
        Question2: "¿Qué problemas tiene con el proceso de negocio de TI actual en torno a Planisware? ¿Alguna sugerencia de mejora?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Wat kunnen we doen om de diensten van het Planisware-team te verbeteren?",
        Question2: "Welke problemen heeft u met het huidige IT-bedrijfsproces rond Planisware? Heeft u suggesties voor verbetering?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Was können wir tun, um die Dienstleistungen des Planisware-Teams zu verbessern?",
        Question2: "Welche Probleme haben Sie mit dem aktuellen IT-Geschäftsprozess rund um Planisware? Haben Sie Verbesserungsvorschläge?",
        optionalText:"(optional)"
      }
    }
  },
  "Other Applications": {
    heading: "Other Application",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)"
      },      
  }, 
  },
  "Windchill application": {
    heading: "Windchill Application",
    translations: {
      English: {
        Question1: "What about Windchill do you think we could do better to make your job easier?",
        Question2: "What features of Windchill do you like?",
        optionalText: "(optional)"
      },
      Chinese: {
        Question1: "您认为我们可以在哪些方面改进 Windchill，以使您的工作更轻松？",
        Question2: "您喜欢 Windchill 的哪些功能？",
        optionalText: "（可选）"
      },
      Japanese: {
        Question1: "Windchill のどの点を改善すれば、仕事がしやすくなると思いますか？",
        Question2: "Windchill のどの機能が好きですか？",
        optionalText:"（任意）"
      },
      French: {
        Question1: "Que pourrions-nous améliorer dans Windchill pour faciliter votre travail ?",
        Question2: "Quelles fonctionnalités de Windchill aimez-vous ?",
        optionalText:"(facultatif)"
      },
      Spanish: {
        Question1: "¿Qué aspectos de Windchill cree que podríamos mejorar para facilitar su trabajo?",
        Question2: "¿Qué características de Windchill le gustan?",
        optionalText:"(opcional)"
      },
      Dutch: {
        Question1: "Wat denkt u dat we aan Windchill kunnen verbeteren om uw werk gemakkelijker te maken?",
        Question2: "Welke functies van Windchill vindt u leuk?",
        optionalText:"(optioneel)"
      },
      German: {
        Question1: "Was könnten wir an Windchill verbessern, um Ihre Arbeit zu erleichtern?",
        Question2: "Welche Funktionen von Windchill gefallen Ihnen?",
        optionalText:"(optional)"
 
      }
    }
  },
  "Weitere Anwendungen": {
    heading: "Weitere Anwendungen",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      German: {
        Question1: "Bitte beschreiben Sie Herausforderungen oder Verbesserungen, die für andere von Ihnen verwendete Anwendungen erforderlich sind.",
        optionalText: "(optional)",
      },      
    },
  },
  "Autre Application": {
    heading: "Autre Application",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      French: {
        Question1: "Veuillez décrire les défis ou améliorations nécessaires pour les autres applications que vous utilisez.",
        optionalText: "(facultatif)",
      },
    },
  },
  "Otra Aplicación": {
    heading: "Otra Aplicación",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      Spanish: {
        Question1: "Describa cualquier desafío o mejora necesaria para otras aplicaciones que use.",
        optionalText: "(opcional)",
      },
    },
  },
  "その他のアプリケーション": {
    heading: "その他のアプリケーション",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      Japanese: {
        Question1: "使用している他のアプリケーションに関する課題や改善の必要性について説明してください。",
        optionalText: "（任意）",
      },
    },
  },
  "其他应用程序": {
    heading: "其他应用程序",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      Chinese: {
        Question1: "请描述您使用的其他应用程序中的任何挑战或改进需求。",
        optionalText: "（可选）",
      },
    },
  },
  "Andere Applicatie": {
    heading: "Andere Applicatiee",
    translations: {
      English: {
        Question1: "Please describe any challenges or improvements needed for other applications you use.",
        optionalText: "(optional)",
      },
      Dutch: {
        Question1: "Beschrijf hieronder eventuele uitdagingen of verbeteringen die nodig zijn voor andere applicaties die u gebruikt.",
        optionalText: "(optioneel)",
      },
    },
  },

};